export const docExampleData = [
  'Tire o documento do plástico',

  'Coloque-o em uma superfície plana',

  'Posicione o documento na vertical com a parte da foto virada para cima',

  'Esteja em um ambiente bem iluminado',
]
